import { render, staticRenderFns } from "./form-component-select-org-user-in-roles.vue?vue&type=template&id=35b4b5e5"
import script from "./form-component-select-org-user-in-roles.vue?vue&type=script&lang=ts"
export * from "./form-component-select-org-user-in-roles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports